import _ from "lodash";

const result = {
  code: 0,
  isSuccess: false,
  msg: "",
  res: null,
  offsetSecond: null,
};

export async function getOffsetMilliSecond(task, { endTimeKey, serverTimeKey }) {
  if (!endTimeKey || !serverTimeKey) {
    throw new Error("endTime, serverTime is necessary");
  }

  try {
    const taskStartFlag = Date.now();
    const res = await task();
    const taskEndFlag = Date.now();

    const endTime = _.get(res, endTimeKey);
    const serverTime = _.get(res, serverTimeKey);

    if (!endTime || !serverTime) {
      return throwErrorReturn({ code: 1 });
    }

    //TODO 优化 (taskEndFlag-taskStartFlag)/2
    const offsetSecond = endTime - serverTime + (taskEndFlag - taskStartFlag) / 2;

    return {
      code: 0,
      isSuccess: true,
      msg: "success",
      res,
      offsetSecond,
    };
  } catch (e) {
    return throwErrorReturn({ code: 1, msg: e.message });
  }
}

function throwErrorReturn({ code, msg }) {
  let custom;
  switch (code) {
    case 1:
      custom = {
        msg,
      };
      break;
    case 2:
      custom = {
        msg: "endTime,serverTime error",
      };
      break;
  }
  return { ...result, ...custom, code };
}
